import script from "./MascotDisplay.vue?vue&type=script&setup=true&lang=ts"
export * from "./MascotDisplay.vue?vue&type=script&setup=true&lang=ts"

import "./MascotDisplay.vue?vue&type=style&index=0&id=2e035da7&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-2e035da7"]])

export default __exports__